import React from 'react';
import '../../Components/Testimonials/Testimonials.css';
import testImage from '../../Assets/Images/test1.webp';

function App() {
  return (
    <div className="container">
      <div className="button-container">
        <button className="view">View More</button>
      </div>
      <div className="content">
        <div className="image-container">
          <img src={testImage} alt="Woman with bag" />
        </div>
        <div className="review-container">
          <div className="rating">
            <span className="star">★</span>
            <span className="star">★</span>
            <span className="star">★</span>
            <span className="star">★</span>
            <span className="star">★</span>
          </div>
          <h2>JASMINE ANAND</h2>
          <p>
            The Aria 3-Way Bag is a versatile and stylish
            accessory, designed to cater to various needs and
            preferences. It is a well-rounded choice for anyone
            seeking a multi-functional and chic bag.
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;
